export default "__VITE_PUBLIC_ASSET__1eb7d680__"